export const CSS = {
	container: 'c-DistanceInput',
	label: 'c-DistanceInput__label',
};

export const Style = {
	[CSS.container]: {
		display: 'flex',
		'align-items': 'center',
	},
};
